import { useState } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  Edit as EditIcon,
  Trash2 as TrashIcon
} from 'react-feather';
import formatMoney from 'src/utils/formatMoney';
import DeleteModal from '../modal/DeleteModal';

const OrderServiceListResults = ({
  services,
  exclude,
  paginate,
  reload,
  edit,
  disabled,
  ...rest
}) => {
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    text: 'Tem certeza que deseja excluir este Serviço ?',
  });

  const excludeService = async (id) => {
    const confirm = await exclude(id);
    if (confirm) {
      setDeleteModal({
        ...deleteModal,
        open: false
      });
      await reload();
    }
  };

  const buttonEdit = (id) => {
    edit(id);
  };

  const deleteService = (id) => {
    setDeleteModal({
      ...deleteModal,
      id,
      open: true,
      confirm: excludeService,
      cancel: () => { }
    });
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        {/* Alterado de minWidth: 1050 para width: '100%' e overflowX: 'auto' */}
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Serviço</TableCell>
                <TableCell align="center">Status Cliente</TableCell>
                <TableCell align="center">Status Serviço</TableCell>
                <TableCell>Técnico</TableCell>
                <TableCell align="right">Valor</TableCell>
                <TableCell align="center">Editar</TableCell>
                {!disabled && <TableCell align="center">Excluir</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {services.map((service) => {
                let styleLine = {};

                if (service.client_status === 'A' && service.status !== 'F') {
                  styleLine = {
                    backgroundColor: '#17A2B8',
                    fontWeight: 'bold',
                    color: '#fff',
                  };
                }

                if (service.client_status === 'R' && service.status !== 'F') {
                  styleLine = {
                    backgroundColor: '#F08080',
                    fontWeight: 'bold',
                    color: '#fff',
                  };
                }

                if (service.client_status === 'A' && service.status === 'F') {
                  styleLine = {
                    backgroundColor: '#4CAF50',
                    fontWeight: 'bold',
                    color: '#fff',
                  };
                }

                // Mantém a cor do texto e do background consistente nas células
                const cellStyle = { ...styleLine, whiteSpace: 'nowrap' };

                return (
                  <TableRow hover key={service.id}>
                    {/* whiteSpace: 'normal' permite que o nome do serviço quebre linha se for muito longo, poupando espaço horizontal */}
                    <TableCell style={{ ...styleLine, whiteSpace: 'normal', minWidth: '180px' }}>
                      {service.service}
                    </TableCell>
                    <TableCell align="center" style={cellStyle}>
                      {service.client_status_details}
                    </TableCell>
                    <TableCell align="center" style={cellStyle}>
                      {service.status_details}
                    </TableCell>
                    <TableCell style={cellStyle}>
                      {service.lastHistory && service.lastHistory.length > 0
                        ? service.lastHistory[0].technician.name
                        : 'Sem'}
                    </TableCell>
                    <TableCell align="right" style={cellStyle}>
                      {formatMoney(service.value)}
                    </TableCell>
                    <TableCell align="center" style={cellStyle}>
                      <Button onClick={() => { buttonEdit(service.id); }} style={{ color: styleLine.color || 'inherit' }}>
                        <EditIcon size={18} />
                      </Button>
                    </TableCell>
                    {!disabled && (
                      <TableCell align="center" style={cellStyle}>
                        <Button onClick={() => { deleteService(service.id); }} style={{ color: styleLine.color || 'inherit' }}>
                          <TrashIcon size={18} />
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <DeleteModal modal={deleteModal} />
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

OrderServiceListResults.propTypes = {
  services: PropTypes.array.isRequired,
  exclude: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  paginate: PropTypes.array.isRequired,
  reload: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default OrderServiceListResults;
